<template>
  <Navbar />
  <Header v-bind:title="title" />
  <Totop />

  <section class="survey-section">
    <TabWrapper>
      <Tab title="學習投入">
        <h2 class="tab-title">學習投入</h2>
        <div class="result-list" v-if="surveys.length">
          <ul>
            <li class="result-list-item" v-for="article in surveys" :key="article.id">
              <SurveyComp :article="article" :category="'learning'"/>
            </li> 
          </ul>
        </div>

      </Tab>

      <Tab title="核心能力">
        <h2 class="tab-title">核心能力</h2>
        <div class="result-list" v-if="surveys.length">
          <ul>
            <li class="result-list-item" v-for="article in surveys" :key="article.id">
                <SurveyComp :article="article" :category="'core'"/>
            </li>
          </ul>
        </div>

      </Tab>
    </TabWrapper>
   </section>
  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import TabWrapper from "@/components/TabWrapper.vue";
import Tab from "@/components/Tab.vue";
import SurveyComp from "@/components/SurveyComp.vue"
import Footer from "@/components/Footer.vue";
import Totop from "@/components/Totop.vue";

import formatted from "@/mixin/formatted";

export default {
  components: { Navbar, Header, TabWrapper, Tab, SurveyComp, Footer, Totop },
  mixins: [formatted],

  data() {
    return {
      title: "問卷調查",
      surveys: []
    };
  },

  mounted() {
    fetch("https://oir.nccu.edu.tw/codeigniter/api/results")
      .then((respond) => respond.json())
      .then((data) => {
        this.surveys = data;
      })
      
      .catch((err) => console.log(err.message));
  },
};
</script>

<style scoped>
.survey-section {
    display: grid;
    grid-template-columns: 180px 1fr;
    grid-template-rows: 70px 70px 70px 70px auto;
    width: 90%;
    max-width: 1024px;
    margin: 20px auto;
    padding: 10px 20px;
    background-color: whitesmoke;
  }
  
.tab-title {
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 24px;
    letter-spacing: 3px;
}

.result-list-item {
    margin:25px;
}

@media  screen and (max-width: 768px) {
  .survey-section {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto 1fr;
    width: 100%;
    padding: 10px 0px
  }

  .tab-title {
    text-align: center;
  }

}

</style>